export default __webpack_public_path__ + "static/media/bsi.cf37d90a.png";